import React, { useState, useRef } from "react";
// import axios from "axios";
import axios from "../../../axiosInstance";

import { AgGridReact } from "@ag-grid-community/react";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-balham-dark.css";
import { Modal, Spinner } from "react-bootstrap";
import { TextField, Icon } from "@shopify/polaris";
import { ImageMajor } from "@shopify/polaris-icons";
const moment = require("moment-timezone");

function ReturnsMenu() {
  const [search, setSearch] = useState("");
  const [modules, setModules] = useState(AllCommunityModules);
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Line Item Id",
      field: "lineitem_id",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "Quantity",
      field: "quantity",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "Refund Status",
      field: "refund_status",
      width: 150,
      suppressSizeToFit: true, 
      cellRenderer: (params) => {
        if (params.value) {
          return "PAID";
        } else {
          return "PENDING";
        }
      },
    },
    {
      headerName: "Tracking Number",
      field: "tracking_number",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "Order Date",
      field: "shopify_order_date",
      width: 150,
      suppressSizeToFit: true, 
      cellRenderer: (params) => {
        if (params.value) {
          return moment
            .utc(params.value)
            .tz("America/New_York")
            .format("MM/DD/YYYY HH:mm:ss");
        } else return "";
      },
    },
    {
      headerName: "Return Date",
      field: "created_date",
      width: 150,
      suppressSizeToFit: true, 
      cellRenderer: (params) => {
        if (params.value) {
          return moment
            .utc(params.value)
            .tz("America/New_York")
            .format("MM/DD/YYYY HH:mm:ss");
        } else return "";
      },
    },
    {
      headerName: "Action",
      //   field: "shipping_label_url",
      width: 150,
      suppressSizeToFit: true, 
      cellRenderer: (params) => {
        const action = document.createElement("div");
        action.className = "downloadLabelButton";
        action.innerHTML = `<a href="${params.data.shipping_label_url}" class="download"><button class="downloadButton">Download</button></a>`;
        return action;
      },
    },
    {
      headerName: "Address Edited",
      field: "isedit",
      width: 150,
      suppressSizeToFit: true, 
      cellRenderer: (params) => {
        if (params.value) {
          return "Yes";
        } else {
          return "No";
        }
      },
    },
    {
      headerName: "Country/region",
      field: "country",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "Address",
      field: "address",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "City",
      field: "city",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "State",
      field: "state",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "ZIP code",
      field: "zipcode",
      width: 150,
      suppressSizeToFit: true, 
    },
    {
      headerName: "Phone",
      field: "phone",
      width: 150,
      suppressSizeToFit: true, 
    },
    
  ]);
  const [defaultColDef, setdefaultColDef] = useState({
    resizable: true,
    domLayout: "autoHeight",
  });
  const [rowData, setRowData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [order, setOrder] = useState({
    orderDetails: {},
    orderId: "",
  });
  const [{ searchLoader, createLoader }, setLoader] = useState(false);
  const [lineItems, setLineItems] = useState([]);
  const [defLineItems, setDefLineItems] = useState([]);
  const [{ error, addressError, upsError, weightError}, setError] = useState(false);
  const [editShippingAdress, setShippingAdress] = useState(false);
  const [editorder, setEditOrder] = useState({
    orderEditDetails: {},
  });
  const [notvalidaddress, setnotvalidaddress] = useState(false);
  const [notvalidcity, setnotvalidcity] = useState(false);
  const [notvalidzipcode, setnotvalidzipcode] = useState(false);
  const [notvalidphone, setnotvalidphone] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [isChecked1, setIsChecked1] = useState(false);

  const gridApi = useRef();

  const handleChange = (e) => {
    if (e.target.value?.length) {
      const value = e.target.value.trim();
      setSearch(value);
    } else setSearch("");
  };

  const handleSearch = () => {
    if (search.length) {
      setLoader((prevState) => ({
        ...prevState,
        searchLoader: true,
      }));
      axios
        .get("/api/shopify/order/search", { params: { value: search } })
        .then((response) => response.data)
        .then(
          (result) => {
            setLoader((prevState) => ({
              ...prevState,
              searchLoader: false,
            }));

            const { success, data } = result;
            if (success) {
              const { returns } = data;
              gridApi.current.setRowData(returns);

              setOrder((prevState) => ({
                ...prevState,
                orderDetails: data.orderDetails,
                orderId: data.orderId,
              }));

              setEditOrder((prevState) => ({
                ...prevState,
                orderEditDetails: data.orderDetails
              }));

              

              const { edges } = data.orderDetails.lineItems;
              edges.map((i, idx) => {
                if (returns.length) {
                  //comparing DB data with shopify data to find the matches
                  const temp = i.node.id.split("/");
                  const lineId = temp[temp.length - 1];
                  const matches = returns.filter(
                    (x) => x.lineitem_id === lineId
                  );

                  // calculating the previously returned and the available quantities
                  if (matches.length) {
                    let qty = 0;
                    matches.map(
                      (m) => (qty = Number(qty) + Number(m.quantity))
                    );
                    i.node.returnQty = qty.toString();
                    // console.log("qty", qty);
                  } else {
                    i.node.returnQty = "0";
                  }
                } else {
                  i.node.returnQty = "0";
                }
                i.node.uniqueisChecked1 = false;
                i.node.returningQty = "0";
                i.node.fulfilledQty =
                  i.node.quantity - i.node.unfulfilledQuantity;
                i.node.remainingQty =
                  Number(i.node.fulfilledQty) -
                  Number(i.node.returnQty).toString();
              });
              
              // filtering only the line items with available quantity > 0
              const filteredItems = edges.filter(
                (i) => i.node.fulfilledQty > i.node.returnQty
              );
              
            //  console.log("setLineItems 1", filteredItems);
              setLineItems(filteredItems);

              const temp = [];
              if (filteredItems.length) {
                filteredItems.map((i) =>
                  temp.push({
                    id: i.node.id,
                    quantity: i.node.quantity,
                    returnQty: i.node.returnQty,
                    returningQty: "0",
                    uniqueisChecked1:false
                  })
                );
              }
              setDefLineItems(temp);
              gridApi.current.sizeColumnsToFit();
            } else {
              gridApi.current.setRowData([]);
              setOrder({
                orderDetails: {},
                orderId: "",
              });
              setEditOrder({
                orderEditDetails: {}
              });
              setShippingAdress(false);
              setnotvalidaddress(false);
              setnotvalidcity(false);
              setnotvalidzipcode(false);
              setnotvalidphone(false);
              setCheckedItems({});
              setIsChecked1(false);
            }
          },
          (error) => {
            setLoader((prevState) => ({
              ...prevState,
              searchLoader: false,
            }));
            console.log(error);
            gridApi.current.setRowData([]);
            setOrder({
              orderDetails: {},
              orderId: "",
            });
            setEditOrder({
              orderEditDetails: {}
            });
            setShippingAdress(false);
            setEditOrder({
              orderEditDetails: {}
            });
            setnotvalidaddress(false);
              setnotvalidcity(false);
              setnotvalidzipcode(false);
              setnotvalidphone(false);
              setCheckedItems({});
              setIsChecked1(false);
          }
        );
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    const gridColumnApi = params.columnApi;
    gridApi.current.showNoRowsOverlay();
    
    const gridWidth = document.getElementById("myGrid").offsetWidth;
  
    if (gridWidth) {
      const allColIds = gridColumnApi
        .getAllColumns()
        .map((column) => column.colId);
      gridColumnApi.autoSizeColumns(allColIds);
      // If you want to resize all columns
      gridColumnApi.autoSizeAllColumns();
    }
  };

  const handleClear = () => {
    setSearch("");
    setOrder({
      orderDetails: {},
      orderId: "",
    });
    setEditOrder({
      orderEditDetails: {}
    });
    setShippingAdress(false);
    setnotvalidaddress(false);
              setnotvalidcity(false);
              setnotvalidzipcode(false);
              setnotvalidphone(false);
              setCheckedItems({});
              setIsChecked1(false);
    gridApi.current.setRowData([]);
  };

  const openPopUp = () => setOpenModel(true);

  const closeModel = (refresh) => {
    if (refresh) {
      const lineItemsCopy = [...lineItems];
      if (defLineItems.length && lineItemsCopy.length) {
        lineItemsCopy.map((i, idx) => {
          i.node.returningQty = defLineItems[idx].returningQty;
          i.node.uniqueisChecked1 =  defLineItems[idx].uniqueisChecked1;
        });
      }
     // console.log("setLineItems 2", lineItemsCopy);
      setLineItems(lineItemsCopy);
      
    }
    setOpenModel(false);
    setShippingAdress(false);
    setEditOrder((prevState) => ({
      ...prevState,
      orderEditDetails: order.orderDetails
    }));
    setnotvalidaddress(false);
              setnotvalidcity(false);
              setnotvalidzipcode(false);
              setnotvalidphone(false);
              setCheckedItems({});
              setIsChecked1(false);
    
  };

  const isCreateValid = () => {
    let result = true;
    if (order.orderDetails.displayFulfillmentStatus) {
      const val = order.orderDetails.displayFulfillmentStatus;
      // if (val === "FULFILLED" || val === "PARTIALLY_FULFILLED") {
      //   result = false;
      // }
      if (val === "FULFILLED") {
        result = false;
      }
    }
    return result;
  };

  const handleQtyChange = (value, index) => {
    const result = [...lineItems];
    result[index].node.returningQty = value;
    //console.log("setLineItems 3", result);
    setLineItems(result);
  };

  const handleCheckboxChange = (item, idx) => {
    const result = [...lineItems];
    result[idx].node.uniqueisChecked1 = item?.target?.checked;
   // console.log("setLineItems 4", result);
    setLineItems(result);
  };

  const handleCheckboxChange1 = (checkboxNumber) => {
    switch (checkboxNumber) {
      case 1:
        setIsChecked1(!isChecked1);
        break;
      default:
        break;
    }
  };

  const editAddressChange =() =>{
    const tempObject=order;
    tempObject.orderDetails.shippingAddress=editorder.orderEditDetails.shippingAddress;
    setOrder(tempObject)
  
    // setOrder((prevState) => ({
    //   orderDetails: {
    //     ...prevState.orderDetails,           // copy all other key-value pairs of food object
    //     shippingAddress: editorder.orderEditDetails.shippingAddress
    //   }
    // }));
  
  }

  const handleCreateReturn = () => {

if(editShippingAdress){

  
  editAddressChange();
  
}
    let lineItemData = [];
    let lineItemReturnQty = 0;
    const lineItemsCopy = [...lineItems];

      // console.log("defLineItems", defLineItems);
      // console.log("lineItems", lineItems );
      // console.log("lineItemsCopy", lineItemsCopy);

    if (lineItemsCopy.length) {
      lineItemsCopy.map((i, idx) => {
        if (
          Number(i.node.returningQty) !== 0 &&
          Number(i.node.returningQty) <= Number(i.node.remainingQty) 
        ) {
          lineItemData.push(i.node);
        }
      });
    }

    if(lineItemData.length){
      if(!isChecked1){
      lineItemData.map((i, idx) => {
        if (
          Number(i.returningQty) !== 0 &&
          Number(i.returningQty) <= Number(i.remainingQty) && (!i.uniqueisChecked1)
        ) {
          lineItemReturnQty += Number(i.returningQty) *  (i?.variant?.weight ? Number(i.variant.weight) : 0)
        }
      });
      }
    //  console.log("lineItemReturnQty", lineItemReturnQty);
  }

    const payload = {
      orderDetails: order.orderDetails,
      lineItems: lineItemData,
      orderId: order.orderId,
      editShippingAdress,
      isChecked1
    };

    const { shippingAddress, customer } = order.orderDetails;
     //  console.log("shippingAddress", shippingAddress);
     // console.log("payload", payload);

    if (
      shippingAddress !== null &&
      customer?.displayName &&
      shippingAddress?.address1 &&
      shippingAddress?.city &&
      shippingAddress?.provinceCode &&
      shippingAddress?.zip &&
      shippingAddress?.countryCodeV2
    ) {
      if(lineItemReturnQty > 70){
        //  console.log("lineItemReturnQty", lineItemReturnQty);
        setLoader((prevState) => ({
          ...prevState,
          createLoader: false,
        }));
        setError((prevState) => ({
          ...prevState,
          weightError: true,
        }));
        setTimeout(() => {
          setError((prevState) => ({
            ...prevState,
            weightError: false,
          }));
          // closeModel(false);
        }, 4000);
        //  console.log("weightError",weightError);
        //  console.log("lineItemReturnQty",lineItemReturnQty);
      }
      else if (lineItemData.length) {
        setLoader((prevState) => ({
          ...prevState,
          createLoader: true,
        }));
        axios
          .post("/api/shopify/order/return", payload)
          .then((response) => response.data)
          .then(
            (result) => {
              setLoader((prevState) => ({
                ...prevState,
                createLoader: false,
              }));
              const { success } = result;
              if (success) {
                // console.log("success");
                handleSearch();
                closeModel(false);
              } else {
                if (result.upsError) {
                  setError((prevState) => ({
                    ...prevState,
                    upsError: true,
                  }));
                  setTimeout(() => {
                    setError((prevState) => ({
                      ...prevState,
                      upsError: false,
                    }));
                  }, 4000);
                } else {
                  setError((prevState) => ({
                    ...prevState,
                    error: true,
                  }));
                  setTimeout(() => {
                    setError((prevState) => ({
                      ...prevState,
                      error: false,
                    }));
                    closeModel(false);
                  }, 4000);
                }
              }
            },
            (error) => {
              setLoader((prevState) => ({
                ...prevState,
                createLoader: false,
              }));
              setError((prevState) => ({
                ...prevState,
                error: true,
              }));
              setTimeout(() => {
                setError((prevState) => ({
                  ...prevState,
                  error: false,
                }));
                closeModel(false);
              }, 4000);
              console.log(error);
            }
          );
      }
    } else {
      // console.log("address fields missing");
      setError((prevState) => ({
        ...prevState,
        addressError: true,
      }));
      setTimeout(() => {
        setError((prevState) => ({
          ...prevState,
          addressError: false,
        }));
      }, 4000);
    }
  };

  const isSaveValid = () => {
    let result = true;
    const lineItemsCopy = [...lineItems];

    if (lineItemsCopy.length) {
      lineItemsCopy.map((i) => {
        const returnQty = Number(i.node.returningQty);
        const max = Number(i.node.remainingQty);
        // if (returnQty > 0 && qty !== 0 && returnQty <= max) result = false;
        if (returnQty > 0 && returnQty <= max){ result = false;}
      });
      
    }
    return result;
  };

  const isSaveValidShipping = () => {
    let result = true;
    

    if (editShippingAdress) {
      if(!notvalidaddress && !notvalidcity && !notvalidzipcode && !notvalidphone){
        result = true;
        return result;
      }else{
        result = false;
        return result;
      }
    }else{
      return result;
    }
   
  };
  
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && e.target.name === "search") {
      handleSearch();
      // else if (e.target.name === "createReturn") handleCreateReturn();
    }
  };

//shipping
  const OpenShippingAdress = (e) => setShippingAdress(e.target.checked);
  const addresschange =(e) => {
    isSaveValidShipping();
    if (!e.target.value){
      setnotvalidaddress(true);
  }else{
    setnotvalidaddress(false);
  }
  setEditOrder((prevState) => ({
    orderEditDetails: {
      ...prevState.orderEditDetails,           // copy all other key-value pairs of food object
      shippingAddress: {                     // specific object of food object
        ...prevState.orderEditDetails.shippingAddress,   // copy all pizza key-value pairs
        address1: e.target.value          // update value of specific key
      }
    }

  }))
  
};
  const citychange =(e) =>  
  {
    isSaveValidShipping();
    let iscityvalid = new RegExp(/^[A-Za-z\s]+$/).test(e.target.value)
    if (!iscityvalid){
      setnotvalidcity(true);
  }else{
    setnotvalidcity(false);
  }
  setEditOrder((prevState) => ({

    orderEditDetails: {
      ...prevState.orderEditDetails,           // copy all other key-value pairs of food object
      shippingAddress: {                     // specific object of food object
        ...prevState.orderEditDetails.shippingAddress,   // copy all pizza key-value pairs
        city: e.target.value          // update value of specific key
      }
    }

  }))
};
  const statechange =(e) => setEditOrder((prevState) => ({
    orderEditDetails: {
      ...prevState.orderEditDetails,           // copy all other key-value pairs of food object
      shippingAddress: {                     // specific object of food object
        ...prevState.orderEditDetails.shippingAddress,   // copy all pizza key-value pairs
        provinceCode: e.target.value          // update value of specific key
      }
    }

  }));
  const zipchange =(e) =>  
  {
    isSaveValidShipping();
    let iszipvalid = new RegExp(/^\d{5}(?:[-\s]\d{4})?$/g).test(e.target.value)
    if (!iszipvalid){


      setnotvalidzipcode(true);
  }else{
    
    setnotvalidzipcode(false);
  }
  setEditOrder((prevState) => ({
    orderEditDetails: {
      ...prevState.orderEditDetails,           // copy all other key-value pairs of food object
      shippingAddress: {                     // specific object of food object
        ...prevState.orderEditDetails.shippingAddress,   // copy all pizza key-value pairs
        zip: e.target.value          // update value of specific key
      }
    }

  }))};
  const phone =(e) => {
    isSaveValidShipping();
  //   let isvaild =  phoneFomatterAndFieldLimiter(e.target.value);
// console.log("isvaild",isvaild)
let isphonevalid = formatPhoneNumber(e.target.value)

    if(isphonevalid){

      setnotvalidphone(false);
    }
      else{
        setnotvalidphone(true)
      }
  setEditOrder((prevState) => ({

  
    
    orderEditDetails: {
      ...prevState.orderEditDetails,           // copy all other key-value pairs of food object
      shippingAddress: {                     // specific object of food object
        ...prevState.orderEditDetails.shippingAddress,   // copy all pizza key-value pairs
        phone: e.target.value          // update value of specific key
      }
    }
  

  }))


  };


function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}
//shipping

  return (
    <div className="returnsMenuWrapper">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            className="mr-4"
            name="search"
            type="text"
            style={{ borderRadius: "4px", height: "30px" }}
            value={search}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Enter the Order Number"
          />
          <button
            className="btn btn-primary mr-4"
            style={{ fontSize: "14px", width: "70px" }}
            disabled={!search || searchLoader}
            onClick={handleSearch}
          >
            {searchLoader ? <Spinner animation="border" /> : "Search"}
          </button>
          <button
            className="btn btn-primary"
            style={{ fontSize: "14px", padding: "4px 10px" }}
            disabled={Object.keys(order).length === 0}
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
        <div>
          <button
            onClick={openPopUp}
            className="btn btn-primary"
            style={{ fontSize: "14px", padding: "4px 10px" }}
            disabled={isCreateValid()}
          >
            Create Return
          </button>
        </div>
      </div>
      <div style={{ width: "100%" }}>
        {Object.keys(order.orderDetails).length > 0 ? (
          <>
            <div>
              <h3>Order Details</h3>
              <div
                className="orderDetailsTable-returns"
                style={{ padding: "10px 0" }}
              >
                <table width="100%" cellPadding={5}>
                  <tr>
                    <th>Order Number</th>
                    <th>Customer</th>
                    <th>Total</th>
                    <th>Fulfillment Status</th>
                  </tr>
                  <tr>
                    <td>
                      {order.orderDetails.name ? order.orderDetails.name : ""}
                    </td>
                    <td>
                      {order.orderDetails.customer
                        ? order.orderDetails.customer.displayName
                        : ""}
                    </td>
                    <td>
                      {order.orderDetails.totalPriceSet
                        ? "$" +
                          parseFloat(
                            `${order.orderDetails.totalPriceSet.shopMoney.amount}`
                          ).toFixed(2)
                        : ""}
                    </td>
                    <td>
                      {order.orderDetails.displayFulfillmentStatus
                        ? order.orderDetails.displayFulfillmentStatus
                        : ""}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </>
        ) : (
          <div className="noRecordsNote">No Records Found</div>
        )}
        <div
          id="myGrid"
          style={{
            height: "60vh",
            "font-size": "14px",
            display:
              Object.keys(order.orderDetails).length > 0 ? "block" : "none",
            paddingTop: "10px",
          }}
          className="ag-theme-balham"
        >
          <AgGridReact
            ref={gridApi}
            modules={modules}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            rowHeight={50}
            headerHeight={60}
            rowData={rowData}
            suppressPaginationPanel={true}
            debounceVerticalScrollbar={true}
            // containerStyle={{minWidth:'90vh'}}
          />
        </div>
      </div>

      <Modal
        show={openModel}
        size="md"
        centered
        onHide={() => closeModel(true)}
        className="createReturnsModel"
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Return</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="createReturns" style={{ padding: "8px 0" }}>
            {lineItems.length > 0 ? (
              <>
                {lineItems.map((item, idx) => {
                  const { node } = item;
                  const { sku } = node;
                  return (
                    <>
                      {sku !== "BDGIFTTAG" && sku !== "BDGIFTBAGTAG" ? (
                        <div key={idx}>
                          <div className="lineItemsWrapper 1234">
                            <div
                              style={{
                                display: "flex",
                                paddingRight: "10px",
                                flexBasis: "80%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  paddingRight: "10px",
                                }}
                              >
                                {node.image ? (
                                  <img
                                    src={node.image.url}
                                    alt="Product"
                                    style={{ height: "30px", width: "30px" }}
                                  />
                                ) : (
                                  <Icon source={ImageMajor} color="base" />
                                )}
                              </div>
                              <div style={{minWidth: "330px"}}>
                                <p style={{ fontWeight: "bold" }}>
                                  {node.title}
                                </p>
                                {sku ? <p className="
                                testnew" style={{float: "left"}}>{sku} </p>: ""}  <p className=" newcheck" 
                                key={idx}>
                                  <span className="" style={{                                 padding: "0px 10px",position: "relative"}}
>Unique Tracking Numbers  </span>
          <input style={{
    
    position:"absolute"}}
            type="checkbox"
            id={idx}
            checked={node.uniqueisChecked1 || false}
            onChange={(checked) => handleCheckboxChange(checked,idx)}
          />
          
        </p>
                                {node?.variant?.weight ? <p>{node.variant.weight}{node.variant.weightUnit ==='POUNDS' ? 'lb': node.variant.weightUnit }</p> : ""}
                              </div>
                            </div>
                            <div className="lineItemReturnQty">
                              <TextField
                                type="number"
                                value={node.returningQty || "0"}
                                min="0"
                                max={node.remainingQty}
                                onChange={(val) => handleQtyChange(val, idx)}
                                autoComplete="off"
                                suffix={`/${node.remainingQty}`}
                              />
                            </div>
                          </div>{" "}

                          
                        </div>
                        
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
                <div>

<div className="space checkboxc">
  <div className="text"> Edit Customer Shipping Address</div>
  <input type="checkbox" checked={editShippingAdress} onChange={OpenShippingAdress} />
</div>

<div className="space checkboxc">
<div className="text">ALL Unique Tracking Numbers </div>
        <input
          type="checkbox"
          id="checkbox1"
          checked={isChecked1}
          onChange={() => handleCheckboxChange1(1)}
        />
       
      </div>
</div>
{editShippingAdress ? (
  <><fieldset>
                    <legend> Shipping address  </legend>
                    <div className="space">
                    <div className="text"> Country/region</div>
                    <select>
                    <option  value={editorder.orderEditDetails.shippingAddress.countryCodeV2} selected >United States</option>
                  </select>
                   </div>
                    <div className="space">
                      <div className="text"> Address</div>
                      <input type="text" className={notvalidaddress ? "boderred" : ''} pattern="/^.{0,35}$/" maxlength="35" value={editorder.orderEditDetails.shippingAddress.address1} onChange={addresschange} />
                    </div>
                    {
                                notvalidaddress && <div className="inputError"><small> Address not valid.</small></div>
                    }
                    <div className="space">
                      <div className="text"> City</div>
                      <input type="text" maxlength="35" pattern="/^[a-zA-Z ]{0,35}$/" className={notvalidcity ? "boderred" : ''} value={editorder.orderEditDetails.shippingAddress.city} onChange={citychange} />
                    </div>
                    {
                                notvalidcity && <div className="inputError"><small> City not valid.</small></div>
                    }
                    <div className="space">
                    <div className="text"> State</div>
                    <select value={editorder.orderEditDetails.shippingAddress.provinceCode} onChange={statechange}>
                    <option  disabled>State</option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AS">American Samoa</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">Washington DC</option><option value="FM">Micronesia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="GU">Guam</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MH">Marshall Islands</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="MP">Northern Mariana Islands</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PW">Palau</option><option value="PA">Pennsylvania</option><option value="PR">Puerto Rico</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VI">U.S. Virgin Islands</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="AA">Armed Forces Americas</option><option value="AE">Armed Forces Europe</option><option value="AP">Armed Forces Pacific</option>
                  </select>
                    </div>
                    <div className="space">
                      <div className="text"> ZIP code</div>
                      <input type="text" className={notvalidzipcode ? "boderred" : ''} maxlength="5" value={editorder.orderEditDetails.shippingAddress.zip} onChange={zipchange} />
                    </div>
                    {
                                notvalidzipcode && <div className="inputError"><small> Zip code not valid.</small></div>
                    }
                    <div className="space">
                      <div className="text"> Phone</div>
                      <input type="tel" pattern="\(\d{3}\)[ ]?\d{3}[-]?\d{4}" className={notvalidphone ? "boderred" : ''} maxlength="16" value={editorder.orderEditDetails.shippingAddress.phone} onChange={phone} />
                    </div>
                    {
                                notvalidphone && <div className="inputError"><small> Phone not valid.</small></div>
                    }
                  </fieldset><> </></>

):<></>}

              </>
            ) : (
              "No Line Items Found"
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {addressError || upsError || error || weightError ? (
            <div style={{ color: "red", marginRight: "auto" }}>
              {addressError
                ? "Some of the Customer Address Fields are Missing"
                : upsError
                ? "Error from UPS: Unable to Create Shipping Label"
                : weightError
                ? "Heavier than the allowable package weight of 70 lbs."
                : "Error: Unable To Create Return"}
            </div>
          ) : (
            ""
          )}
          <button
            className="btn btn-primary submitBtn"
            onClick={handleCreateReturn}
            disabled={((isSaveValid() && isSaveValidShipping() ) || createLoader ) }
          >
            {createLoader ? <Spinner animation="border" /> : "Submit"}
          </button>
          <button className="btn btn-primary" onClick={() => closeModel(true)}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReturnsMenu;
